import { c as _c } from "react/compiler-runtime";
/* eslint-disable max-len */
export function IconSidebar(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M1 12H11C11.55 12 12 11.55 12 11C12 10.45 11.55 10 11 10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12ZM0 1C0 1.55 0.45 2 1 2H11C11.55 2 12 1.55 12 1C12 0.45 11.55 0 11 0H1C0.45 0 0 0.45 0 1ZM1 7H11C11.55 7 12 6.55 12 6C12 5.45 11.55 5 11 5H1C0.45 5 0 5.45 0 6C0 6.55 0.45 7 1 7Z" fill="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function IconFullscreen(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M2.0498 6.34961V11.9502H7.65039V13.6504H0.349609V6.34961H2.0498Z" fill="currentColor" stroke="currentColor" strokeWidth="0.3" />;
    t2 = <path d="M12.9502 7.65039L12.9502 2.0498L7.34961 2.04981L7.34961 0.34961L14.6504 0.349609L14.6504 7.65039L12.9502 7.65039Z" fill="currentColor" stroke="currentColor" strokeWidth="0.3" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function IconMinimize(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect width="14" height="2" fill="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function IconBell(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8 16C9.1 16 10 15.1 10 14H6C6 15.1 6.9 16 8 16ZM14 10V6.5C14 4.02 12.49 1.89 10 1.18V0.5C10 -0.17 9.33 -0.5 8 -0.5S6 -0.17 6 0.5V1.18C3.51 1.89 2 4.02 2 6.5V10L0 12V13H16V12L14 10ZM12 11H4V6.5C4 4.57 5.57 3 8 3S12 4.57 12 6.5V11Z" fill="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function IconBellOff(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8 16C9.1 16 10 15.1 10 14H6C6 15.1 6.9 16 8 16ZM14 10V6.5C14 4.02 12.49 1.89 10 1.18V0.5C10 -0.17 9.33 -0.5 8 -0.5S6 -0.17 6 0.5V1.18C3.51 1.89 2 4.02 2 6.5V10L0 12V13H16V12L14 10ZM12 11H4V6.5C4 4.57 5.57 3 8 3S12 4.57 12 6.5V11Z" fill="currentColor" opacity="0.4" />;
    t2 = <path d="M2 1L1 2L15 16L16 15L2 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}